export default "__VITE_ASSET__tGSOKVjB__"